/**
 * @file Keeps an object alive that is passed to all feature aggregate modules.
 * The purpose is to have a way for communication and signals to relay across features at runtime.
 * This object can hold any arbitrary values and should be treated as on-the-fly dynamic.
 */
var onReplayReady;
var sessionReplayInitialized = new Promise(function (resolve) {
  onReplayReady = resolve;
});
export var sharedChannel = Object.freeze({
  onReplayReady: onReplayReady,
  sessionReplayInitialized: sessionReplayInitialized
});